import useForm from '@components/form/hooks/useForm';
import { getMfaIsPosting, getMfaPostError, getMfaPostSuccess } from '@selectors/mfa';
import { useCallback, useEffect } from 'react';
import usePrevious from 'lib/src/hooks/usePrevious';
import { useDispatch, useSelector } from 'react-redux';
import { postMfaVerification } from '@actions/mfa/postMfaVerification';
import { fetchProfile } from '@actions/profile/fetchProfile';

const usePostMfaVerification = (hasMfa: boolean, closeAction?: () => void) => {
    const dispatch = useDispatch();
    const isPosting = useSelector(getMfaIsPosting);
    const postError = useSelector(getMfaPostError);
    const postSuccess = useSelector(getMfaPostSuccess);

    const prevPostSuccess = usePrevious(postSuccess);

    const [formState, handleChange] = useForm({
        mfaToken: '',
    });

    const handleSubmit = useCallback(() => {
        dispatch(
            postMfaVerification(
                { mfaToken: formState.mfaToken.trim().replaceAll(' ', '') },
                hasMfa,
            ),
        );
    }, [dispatch, formState, hasMfa]);

    useEffect(() => {
        if (!prevPostSuccess && postSuccess) {
            dispatch(fetchProfile());
            if (closeAction) {
                closeAction();
            }
        }
    }, [dispatch, postSuccess, prevPostSuccess, closeAction]);

    return {
        isPosting,
        postError,
        formState,
        handleChange,
        handleSubmit,
    };
};

export default usePostMfaVerification;
